import Obeyman from 'obeyman';
import {
    message as Message
} from 'ant-design-vue';

function foreRequestMiddleWare(apiMeta, data, next) {
    const { name, schema } = apiMeta;

    try {
        Object.keys(data).forEach(key => {
            const value = data[key];
            if (value === undefined || value === null) {
                delete data[key];
            }
        })

        if (schema) {
            Obeyman.validate(data, schema, (_, stack) => {
                if (_) {
                    console.warn(`Api [${name}] validate failed\n`, stack);
                }
            })
        }

        next();
    } catch (error) {
        next(error);
    }
}

function fallbackMiddleWare(apiMeta, error, next) {
    // Message.error(apiMeta.name + '错误，请联系管理员！')
    // console.error(error)
    next(error);
}

export default {
    foreRequestMiddleWare,
    fallbackMiddleWare
}